import { render } from "./fbx-button.vue?vue&type=template&id=2fd0b825&scoped=true"
import script from "./fbx-button.vue?vue&type=script&lang=js"
export * from "./fbx-button.vue?vue&type=script&lang=js"

import "./fbx-button.vue?vue&type=style&index=0&id=2fd0b825&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd0b825"]])

export default __exports__